import { Api } from "./base";

const _headers = () => {
  return {
    Authorization:
      "JWT " + require("store").default.getState().onboard.user.auth_token,
    "Content-Type": "application/json"
  };
};

export default {
  getWords(offset, filterString = "") {
    return Api.getCsv(`/wg_and_pictionary/v1/admin-wordgame-words?offset=${offset}${filterString}`, _headers());
  },
  getWordById(id) {
    return Api.get(`/wg_and_pictionary/v1/admin-wordgame-words/${id}/`, _headers());
  },
  createWord(payload) {
    return Api.post(`/wg_and_pictionary/v1/admin-wordgame-words`, payload, _headers());
  },
  updateWordById(id, payload) {
    return Api.put(`/wg_and_pictionary/v1/admin-wordgame-words/${id}`, payload, _headers());
  },
  deleteWordById(id) {
    return Api.deleteCall(`/wg_and_pictionary/v1/admin-wordgame-words/${id}`, _headers());
  }
};
